module.exports = __webpack_public_path__ + "media/1.edd52c29.wav";